import type {Features} from '@/types/features.types';
import type {ValueOf} from '@myparcel-frontend/types';
import {Platform} from '@myparcel-frontend/iam-service';
import {ConfigKey} from '@myparcel-frontend/types';
import {myparcel_belgie} from './myparcel-belgie';
import {myparcel_italie} from './myparcel-italie';
import {myparcel_nederland} from './myparcel-nederland';

type Mapping = Record<ValueOf<typeof ConfigKey>, Features>;

const mapping: Mapping = {
  [ConfigKey.Default]: myparcel_nederland,
  [ConfigKey.MyParcelNl]: myparcel_nederland,
  [ConfigKey.MyParcelBe]: myparcel_belgie,
  [ConfigKey.MyParcelIt]: myparcel_italie,
};

const features = (key: keyof typeof mapping): Features => {
  return mapping.hasOwnProperty(key) ? mapping[key] : mapping[ConfigKey.Default];
};

export default features;

const platformMapping: Record<string, Features> = {
  [Platform.MYPARCEL_NL]: myparcel_nederland,
  [Platform.MYPARCEL_BE]: myparcel_belgie,
  [Platform.MYPARCEL_IT]: myparcel_italie,
};

export const getFeaturesByPlatform = (platform?: string): Features => {
  if (!platform) {
    throw new Error('Cannot resolve features: platform is missing');
  }

  const features = platformMapping[platform];

  if (!features) {
    throw new Error(`Cannot resolve features: unknown platform "${platform}"`);
  }

  return features;
};
